import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './geo-filter-constants';
import { searchAddressFailure, searchAddressSuccess } from './geo-filter-actions';

export function* doSearchAddresses(action) {
  try {
    const { value, endpoint } = action.payload;
    const results = yield call(callApi, {
      endpoint: endpoint?.replace('api/', ''),
      options: {
        method: 'POST',
        body: JSON.stringify({
          query: value,
        }),
        errorMessage: `Could not fetch search results for ${value}`,
        retryAction: action,
      },
    });
    yield put(searchAddressSuccess(results));
  } catch (err) {
    yield put(searchAddressFailure(err));
  }
}

function* watchSearchAddresses() {
  yield takeLatest(actionTypes.SEARCH_ADDRESS_REQUEST, doSearchAddresses);
}

export default [
  fork(watchSearchAddresses),
];
